import { render, staticRenderFns } from "./OutboundList.vue?vue&type=template&id=25f272ba&scoped=true"
import script from "./OutboundList.vue?vue&type=script&lang=js"
export * from "./OutboundList.vue?vue&type=script&lang=js"
import style0 from "./OutboundList.vue?vue&type=style&index=0&id=25f272ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f272ba",
  null
  
)

export default component.exports